import React from "react";
import { connect } from "react-redux";
import {
  getLicensePrice,
  getLicenseTotalPrice,
  formatPrice,
  validUrl,
} from "../../../utilities";
import AuthField from "../../../Shared/AuthField";
import TermsAndConditions from "../../../Shared/TermsAndConditions";
import LicenseTerms from "./_license_terms";
import { receiveValidationErrors } from "../../../Shared/Errors/errorActions";

class LicenseRequestReceived extends React.Component {
  state = {
    downloadLink: "",
    termsAccepted: false,
  };

  acceptAgreement = (accepted) => {
    const { downloadLink } = this.state;
    const { note } = this.props;
    const data = accepted ? { accept: true, downloadLink } : { decline: true };
    data.total_license_price = getLicenseTotalPrice(note);
    data.influencer_royalties = getLicensePrice(note);
    if (this._validate()) {
      this.props.acceptAgreement(data);
    }
  };

  _validate = () => {
    let isValid = false;
    const { downloadLink } = this.state;
    const { dispatch } = this.props;
    if (!downloadLink || validUrl(downloadLink)) {
      isValid = true;
    } else {
      dispatch(
        receiveValidationErrors({
          downloadLink:
            "Please enter a valid url, starting with 'http' or 'https'.",
        })
      );
    }
    return isValid;
  };

  render() {
    const { status, validationErrors, royalties } = this.props;
    const { downloadLink, termsAccepted } = this.state;

    return (
      <div>
        {status !== "DECLINED" && (
          <div>
            <div>
              {status === "PENDING" && (
                <AuthField
                  header="Please paste a Dropbox or similar cloud based shared folder link that licensee can access for downloading the video file:"
                  required
                  name="downloadLink"
                  value={downloadLink}
                  update={(options) =>
                    this.setState({ downloadLink: options.target.value })
                  }
                  noIcon
                  type="text"
                  placeholder="https://"
                  error={validationErrors.downloadLink}
                />
              )}
              <TermsAndConditions
                termsAccepted={termsAccepted}
                onChange={(options) =>
                  this.setState({ termsAccepted: options.target.checked })
                }
                readOnly={status === "ACCEPTED"}
                termsLinkText="Terms of the License of Creator Content"
              >
                <LicenseTerms
                  acceptTerms={() => this.setState({ termsAccepted: true })}
                />
              </TermsAndConditions>
            </div>
          </div>
        )}
        {status === "ACCEPTED" && (
          <div className="license-buttons">
            <div className="btn license-accepted">
              <i className="icon-handshake" />
              Accepted
            </div>
            <span>
              {`You will be paid a total of ${formatPrice(
                royalties
              )} for your video license. We are
                  currently waiving the 3% fee for all creators on the platform as our
                  thank you.`}
            </span>
          </div>
        )}
        {status === "PENDING" && (
          <div className="license-buttons">
            <button
              type="button"
              className="button"
              onClick={() => this.acceptAgreement(true)}
              disabled={!this.state.termsAccepted || !this.state.downloadLink}
            >
              <i className="icon-handshake" />
              Accept License Offer
            </button>
            <button
              type="button"
              className="button decline"
              onClick={() => this.acceptAgreement(false)}
            >
              Decline offer
            </button>
            <span>
              If you have more questions, ask before accepting in the chat
              above.
            </span>
          </div>
        )}
        {status === "DECLINED" && (
          <div className="license-buttons">
            <div className="button license-declined" disabled>
              Declined offer
            </div>
            <span>
              To potentially receive a better offer, send the brand manager a
              message above.
            </span>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ errors }) => ({
  validationErrors: errors.validationErrors,
});

export default connect(mapStateToProps)(LicenseRequestReceived);
